<template>
  <div id="app">
    <!-- The signed-out landing page (/) is a standalone marketing surface that
         renders its own nav + footer, so the app chrome is hidden there. -->
    <NavBar v-if="!isLanding"/>
    <main class="main">
      <router-view/>
    </main>
    <AppFooter v-if="!isLanding"/>
  </div>
</template>

<script>
// @ is an alias to /src
import NavBar from '@/components/NavBar.vue'
import AppFooter from "@/components/Footer.vue";

export default {
  components: {
    AppFooter,
    NavBar
  },
  computed: {
    isLanding() {
      return this.$route.name === 'Home';
    },
  },
}
</script>

<style>
html, body {
  height: 100%;
  margin: 0;
}

#app {
  font-family: var(--font-sans);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--text);
  background: var(--bg);
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  transition: background .25s, color .25s;
}

/* Full-bleed main; individual views own their max-width + padding to match
   the design's per-screen layout. */
.main {
  flex-grow: 1;
  width: 100%;
  padding: 0;
}

footer {
  margin-top: auto; /* Pushes the footer to the bottom */
  flex-shrink: 0; /* Prevents the footer from shrinking */
}
</style>
